import {
    CHECK_WALLET_WELCOME,
    CHECK_WALLET_STATS_SETTED,
    CHECK_WALLET_STATS_PROCESSING,
    CHECK_WALLET_PROCESSING
} from "../consts/consts";

const initialState = {
    status: CHECK_WALLET_WELCOME
};

const processingState = {
    status: CHECK_WALLET_PROCESSING
};

const updateCheckWallet = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case CHECK_WALLET_STATS_SETTED:
            return action.payload;
        case CHECK_WALLET_STATS_PROCESSING:
            return processingState;
        default:
            return state.checkWallet;
    }

};

export {
    updateCheckWallet
}